"use strict";

function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!_instanceof(instance, Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
/**
 * BulkLazyload is a plugin inspirated by lazyloader under WTFPL
 *
 * @licence WTFPL 2018
 * @author Golga <r-ro@bulko.net> for Bulko
 *
 * Dependecies
 * ES6, Jquery 1 || 2 || 3
 *
 * How to use it
 *
 * In your main js file import this file
 * `import BulkLazyload from './{YOUR-PATH}/bulkLazyload';`
 *
 * Then init this plugin in your document.ready (or ready function for turbolinks users)
 * `let bulkLazyload = new BulkLazyload();`
 * `bulkLazyload.init();
 */


var BulkLazyload = /*#__PURE__*/function () {
  function BulkLazyload() {
    _classCallCheck(this, BulkLazyload);
  }

  _createClass(BulkLazyload, [{
    key: "init",
    value: function init() {
      this.lazywatcher();
    }
    /**
     * @author Golga <r-ro@bulko.net>
     * @since 1.1.0 ( 2018-07-09 )
     *
     * @return Void
     */

  }, {
    key: "lazywatcher",
    value: function lazywatcher() {
      var bulkLazyload = this;
      $(window).on('scroll', function () {
        bulkLazyload.loadwithlazyiness();
      });
      $(window).on('hashchange', function (e) {
        bulkLazyload.loadwithlazyiness();
      });
      bulkLazyload.loadwithlazyiness();
    }
    /**
     * @author Golga <r-ro@bulko.net>
     * @since 1.2.3 ( 2018-07-12 )
     *
     * @return Void
     */

  }, {
    key: "loadwithlazyiness",
    value: function loadwithlazyiness() {
      var bulkLazyload = this;
      $('.lazyload').each(function () {
        var elem = this;

        if (bulkLazyload.checkVisible(elem)) {
          bulkLazyload.lazyload($(elem));
        }
      });
    }
  }, {
    key: "lazyload",

    /**
     * @author Golga <r-ro@bulko.net>
     * @since 1.2.3 ( 2018-07-12 )
     *
     * @param jQueryObj $elem
     * @return Void
     */
    value: function lazyload($elem) {
      if ($elem.prop("tagName") === "img" || $elem.prop("tagName") === "IMG" || $elem.prop("tagName") === "iframe" || $elem.prop("tagName") === "IFRAME") {
        $elem.attr('src', $elem.attr("data-lazy"));
      } else {
        $elem.css("background-image", "url(" + $elem.attr("data-lazy") + ")");
      }

      $elem.removeClass('lazyload');
    }
    /**
     * @author Golga <r-ro@bulko.net>
     * @since Legacy
     *
     * @param String elem (selector)
     * @param String evalType
     * @return Bool
     */

  }, {
    key: "checkVisible",
    value: function checkVisible(elem, evalType) {
      evalType = evalType || "visible";
      var vpH = $(window).height(),
          // Viewport Height
      st = $(window).scrollTop(),
          // Scroll Top
      y = $(elem).offset().top,
          elementHeight = $(elem).height();

      if (evalType === "visible") {
        return y < vpH + st && y > st - elementHeight;
      } else if (evalType === "above") {
        return y < vpH + st;
      }

      return false;
    }
  }]);

  return BulkLazyload;
}();